import { render } from "./page-statistics.vue?vue&type=template&id=e316f502&scoped=true"
import script from "./page-statistics.vue?vue&type=script&lang=js"
export * from "./page-statistics.vue?vue&type=script&lang=js"

import "./page-statistics.vue?vue&type=style&index=0&id=e316f502&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e316f502"]])

export default __exports__